import _classCallCheck from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Vector3 } from '../math/Vector3.js';
import { Color } from '../math/Color.js';
import { Object3D } from '../core/Object3D.js';
import { Mesh } from '../objects/Mesh.js';
import { MeshBasicMaterial } from '../materials/MeshBasicMaterial.js';
import { OctahedronGeometry } from '../geometries/OctahedronGeometry.js';
import { BufferAttribute } from '../core/BufferAttribute.js';

var _vector = /*@__PURE__*/new Vector3();

var _color1 = /*@__PURE__*/new Color();

var _color2 = /*@__PURE__*/new Color();

var HemisphereLightHelper = /*#__PURE__*/function (_Object3D) {
  _inherits(HemisphereLightHelper, _Object3D);

  var _super = _createSuper(HemisphereLightHelper);

  function HemisphereLightHelper(light, size, color) {
    var _this;

    _classCallCheck(this, HemisphereLightHelper);

    _this = _super.call(this);
    _this.light = light;

    _this.light.updateMatrixWorld();

    _this.matrix = light.matrixWorld;
    _this.matrixAutoUpdate = false;
    _this.color = color;
    var geometry = new OctahedronGeometry(size);
    geometry.rotateY(Math.PI * 0.5);
    _this.material = new MeshBasicMaterial({
      wireframe: true,
      fog: false,
      toneMapped: false
    });
    if (_this.color === undefined) _this.material.vertexColors = true;
    var position = geometry.getAttribute('position');
    var colors = new Float32Array(position.count * 3);
    geometry.setAttribute('color', new BufferAttribute(colors, 3));

    _this.add(new Mesh(geometry, _this.material));

    _this.update();

    return _this;
  }

  _createClass(HemisphereLightHelper, [{
    key: "dispose",
    value: function dispose() {
      this.children[0].geometry.dispose();
      this.children[0].material.dispose();
    }
  }, {
    key: "update",
    value: function update() {
      var mesh = this.children[0];

      if (this.color !== undefined) {
        this.material.color.set(this.color);
      } else {
        var colors = mesh.geometry.getAttribute('color');

        _color1.copy(this.light.color);

        _color2.copy(this.light.groundColor);

        for (var i = 0, l = colors.count; i < l; i++) {
          var color = i < l / 2 ? _color1 : _color2;
          colors.setXYZ(i, color.r, color.g, color.b);
        }

        colors.needsUpdate = true;
      }

      mesh.lookAt(_vector.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
  }]);

  return HemisphereLightHelper;
}(Object3D);

export { HemisphereLightHelper };